
<script>
import BarList from '../components/bar-list'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
  data() {

    return {
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      metadata: this.$store.getters.getEntities.metadata,
      filter: '',
    }
  },

  computed: {
    ivaclassList: function () {
      return this.$store.getters.getivaclassList
    }
  },

  methods: {
    closeForm() {
      this.showForm = false
    },

    search(value) {
      //efetua a pesquisa
      this.filter = '{"$or":[{"ncm":{"$like":"%25' + value + '%25"}},{"cclass":{"$like":"%25' + value + '%25"}},{"desst":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}'
      this.loadData()
    },

    loadData() {
      this.$store.dispatch('loadivaclass', { filter: this.filter })
    }

  },

  components: {
    BarList
  },

  created() {
    this.loadData()
  }

}

</script>

<template>
  <div>
    <div id="list" v-show="!showForm">
      <bar-list :refresh-button="true" :new-button="false" :pdf-button="false" :xls-button="false"
        single-entity="Classificação Tributária do IBS e CBS " plural-entity="Classificações Tributária do IBS e CBS "
        @search="search" @refresh="loadData" title-search="Pesquise pelo NCM ou pelo Classificação">
      </bar-list>
      <br>
      <div class="default-container">
        <alert v-if="ivaclassList.length == 0" type="norecord"></alert>
        <div class="mainbox" v-for="ivaclass in ivaclassList" v-bind:key="ivaclass.cclass">
          <div class="mark-green"></div>
          <div class="box">
            <div class="row">
              <div class="col-md-10 col-12">
                <span class="lbl-title-produto">{{ ivaclass.nome }} </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Cod. Class </label><span class="data-list">{{
                    ivaclass.cclass
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> CST </label><span class="data-list">{{
                    ivaclass.cst
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Desc. CST </label><span class="data-list">{{
                    ivaclass.desst
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Nome </label><span class="data-list">{{
                    ivaclass.nome
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Descrição </label><span class="data-list">{{
                    ivaclass.des
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> % Red. CBS </label><span class="data-list">{{
                    ivaclass.predcbs
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> % Red. IBS </label><span class="data-list">{{
                    ivaclass.predibs
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Trib. Regular </label><span class="data-list">{{
                    ivaclass.gtribregular
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Cred. Pres. </label><span class="data-list">{{
                    ivaclass.credpres
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Redutor Bc. </label><span class="data-list">{{
                    ivaclass.redutorbc
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Mono </label><span class="data-list">{{
                    ivaclass.mono
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Mono Ret. </label><span class="data-list">{{
                    ivaclass.monoret
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Mono Reten </label><span class="data-list">{{
                    ivaclass.monoreten
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> Mono Dif. </label><span class="data-list">{{
                    ivaclass.monodif
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> G. ibscbs </label><span class="data-list">{{
                    ivaclass.ind_gibscbs
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> G. Ibscbsmono </label><span class="data-list">{{
                    ivaclass.ind_gibscbsmono
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> G. red </label><span class="data-list">{{
                    ivaclass.ind_gred
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> G. Dif. </label><span class="data-list">{{
                    ivaclass.ind_gdif
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> G. Transf Cred </label><span class="data-list">{{
                    ivaclass.ind_gtransfcred
                }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/ivaclass-list.vue